'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002415 from "./presto.-Freemium2-F-A-Add-View$$anon$15.js";
import * as $j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult$0024 from "./presto.types$-Freemium-Seed-Result$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$14() {
  this.aTk = null;
  this.aTc = null;
  this.aTd = false;
  this.aTl = null;
  this.aTm = false;
  this.aTp = null;
  this.aTi = null;
  this.aTj = false;
  this.aTe = null;
  this.aTf = false;
  this.aTg = null;
  this.aTh = false;
  this.aTn = false;
  this.aTo = false;
  this.aTk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aTp = "FreemiumSeedResult";
}
export { $c_Lpresto_Freemium2FAAddView$$anon$14 as $c_Lpresto_Freemium2FAAddView$$anon$14 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$14;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$14() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$14 as $h_Lpresto_Freemium2FAAddView$$anon$14 };
$h_Lpresto_Freemium2FAAddView$$anon$14.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aTk;
});
$p.L = (function() {
  if ((!this.aTd)) {
    this.aTc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aTd = true;
  }
  return this.aTc;
});
$p.O = (function() {
  if ((!this.aTm)) {
    this.aTl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aTm = true;
  }
  return this.aTl;
});
$p.E = (function() {
  return this.aTp;
});
$p.t = (function() {
  if ((!this.aTj)) {
    this.aTi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("error", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aTj = true;
  }
  return this.aTi;
});
$p.M = (function() {
  if ((!this.aTf)) {
    this.aTe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aTf = true;
  }
  return this.aTe;
});
$p.Q = (function() {
  if ((!this.aTh)) {
    this.aTg = new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002415.$c_Lpresto_Freemium2FAAddView$$anon$15();
    this.aTh = true;
  }
  return this.aTg;
});
$p.w = (function() {
  if ((!this.aTo)) {
    this.aTn = false;
    this.aTo = true;
  }
  return this.aTn;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee133) => ((p) => \u03b4scrutinee133.cGs(p)))($j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult$0024.$m_Lpresto_types$FreemiumSeedResult$())));
});
var $d_Lpresto_Freemium2FAAddView$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$14, "presto.Freemium2FAAddView$$anon$14", ({
  II: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$14 as $d_Lpresto_Freemium2FAAddView$$anon$14 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$14.js.map
